module.exports = __webpack_public_path__ + "img/lanscape-3.831b9d85.webp";